import { render, staticRenderFns } from "./ifp-filter-entities.vue?vue&type=template&id=ca7c0700&"
import script from "./ifp-filter-entities.vue?vue&type=script&lang=ts&"
export * from "./ifp-filter-entities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports